<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item" aria-current="page">
                <router-link to="/stockout">{{$t('stock_out_list')}}</router-link>
            </li>
            <li class="breadcrumb-item" aria-current="page">{{title}} <span v-if="header.InvoiceNo">[{{header.InvoiceNo}}]</span></li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button> 
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="save"><i class="fa fa-floppy-o"></i> {{$t('save')}}</button>
        </div>
        <div class="x_body">
            <div class="card f_card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label class="control-label blue">{{$t('branch')}}</label>
                                <div>
                                    <select class="form-control form-control-sm" v-model="header.BranchId">
                                        <option v-for="ret in branchs" :value="ret.Id" :key="ret.Id">{{ ret.Name }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label class="control-label blue">{{$t('stock_controller')}}</label>
                                <div>
                                    <select class="form-control form-control-sm" v-model="header.EmployeeId">
                                        <option value=""></option>
                                        <option v-for="ret in employees" :value="ret.Id" :key="ret.Id">{{ ret.Code + ' : ' + ret.Name }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-3">
                            <div class="form-group">
                                <label class="control-label blue">{{$t('driver')}}</label>
                                <div>
                                    <select class="form-control form-control-sm" v-model="header.DriverId">
                                        <option value=""></option>
                                        <option v-for="ret in employees" :value="ret.Id" :key="ret.Id">{{ ret.Code + ' : ' + ret.Name }}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-2">
                            <div class="form-group">
                                <label class="control-label blue">{{$t('date')}}</label>
                                <div>
                                    <input type="date" class="form-control form-control-sm" v-model="header.OutDateAt"/>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br/>
                    <div class="row">
                        <div class="col-sm-12">
                            <table class="table table-bordered table-sm table-grid no-bor">
                                <thead>
                                    <tr>
                                        <th class="text-center" style="width: 50px;">{{$t('no')}}</th>
                                        <th>{{$t('code')}}</th>
                                        <th>{{$t('item_name')}}</th>
                                        <th>{{$t('description')}}</th>
                                        <th style="width: 120px;">{{$t('uom')}}</th>
                                        <th style="width: 120px;">{{$t('qty')}}</th>
                                        <th style="width: 120px;">{{$t('qty_out')}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(ret, index) in lines" :key="index">
                                        <td class="text-center">{{index + 1}}</td>
                                        <td>{{ret.ItemCode}}</td>
                                        <td>{{ret.ItemName}}</td>
                                        <td class="cell-input"><input type="text" class="form-control form-control-sm" v-model="ret.Description" /></td>
                                        <td>{{ret.UomName}}</td>
                                        <td>{{ret.Quantity}}</td>
                                        <td class="cell-input"><input type="number" class="form-control form-control-sm" v-model="ret.QuantityOut" :disabled="ret.ItemId==''" /></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return {
            title: this.$t('request_stockout'),
            branchs: [],
            header: {
                DocSource: 'Invoice'
            },
            lines: [],
            employees: [],
            isCheck: false,
            stockdate: this.$now().format('YYYY-MM-DD'),
            action: 'stockout/save'
        }
    },
    created(){
        this.getBranch();
        this.getEmployee();
        var id = this.$route.params.id;
        if(id != undefined && id != null && id != ''){
            this.findById(id);
        }
    },
    methods: {
        getBranch: async function() {
            var res = await this.$api().post('branch/list', { Limit: 0 });
            if(this.$isValid(res)){
                this.branchs = res.data.Data;
            }
        },
        save(){
            var loading = this.$loading.show();
            var req = {
                Header: this.header,
                Lines: this.lines
            };
            this.$api().post(this.action, req).then(res => {
                if(this.$isValid(res)){
                    this.$router.go(-1);
                }
            }).finally(function() { loading.hide(); });
        },
        findById(id){
            var loading = this.$loading.show();
            this.$api().post('sale/invoice/stockout', { Id: id }).then(res => {
                if(this.$isValid(res)){
                    var data = res.data.Json;
                    this.header = data.Header;
                    this.lines = data.Lines;
                    this.header.OutDateAt = this.$now().format('YYYY-MM-DD');
                }
            }).finally(function() { loading.hide(); });
        },
        getEmployee: async function(){
            var res = await this.$api().post('employee/select');
            if(this.$isValid(res)){
                this.employees = res.data.Json.Employees;
            }
        }
    }
}
</script>
<style scoped>
    .table-grid .form-control{
        border:none;
        border-radius: 0;
    }
    .table-grid .cell-input{
        padding: 0;
    }
</style>